"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stytchFetchEmailResendMessage = exports.stytchFetchEmailExchangeAccessCode = exports.stytchFetchEmailSignIn = exports.stytchFetchEmailSignUp = void 0;
const query_string_1 = __importDefault(require("query-string"));
const headers_1 = require("../headers");
function stytchFetchEmailSignUp(email, name, termsAccepted, enableNewsletter, userServiceAddress, basePath, redirect, source) {
    const url = query_string_1.default.stringifyUrl({
        url: `${userServiceAddress}/auth/magic/signup`,
    });
    return fetch(url, {
        method: 'POST',
        headers: headers_1.headers,
        body: JSON.stringify({
            email,
            name: {
                first_name: name.firstName,
                middle_name: name.middleName,
                last_name: name.lastName,
            },
            terms_accepted: termsAccepted,
            enable_newsletter: enableNewsletter,
            base_path: basePath,
            redirect,
            source,
        }),
    });
}
exports.stytchFetchEmailSignUp = stytchFetchEmailSignUp;
function stytchFetchEmailSignIn(email, userServiceAddress, basePath, redirect) {
    const url = query_string_1.default.stringifyUrl({
        url: `${userServiceAddress}/auth/magic/signin`,
    });
    return fetch(url, {
        method: 'POST',
        headers: headers_1.headers,
        body: JSON.stringify({
            email,
            base_path: basePath,
            redirect,
        }),
    });
}
exports.stytchFetchEmailSignIn = stytchFetchEmailSignIn;
function stytchFetchEmailExchangeAccessCode(code, userServiceAddress, termsAccepted, enableNewsletter, basePath, source) {
    const url = query_string_1.default.stringifyUrl({
        url: `${userServiceAddress}/auth/magic/auth`,
    });
    return fetch(url, {
        method: 'POST',
        headers: headers_1.headers,
        body: JSON.stringify({
            token: code,
            terms_accepted: termsAccepted,
            enable_newsletter: enableNewsletter,
            base_path: basePath,
            source,
        }),
    });
}
exports.stytchFetchEmailExchangeAccessCode = stytchFetchEmailExchangeAccessCode;
function stytchFetchEmailResendMessage({ userId, email, termsAccepted, enableNewsletter, basePath, userServiceAddress, redirect, }) {
    const url = query_string_1.default.stringifyUrl({
        url: `${userServiceAddress}/auth/magic/send`,
    });
    return fetch(url, {
        method: 'POST',
        headers: headers_1.headers,
        body: JSON.stringify({
            base_path: basePath,
            user_id: userId,
            email,
            terms_accepted: termsAccepted,
            enable_newsletter: enableNewsletter,
            redirect,
        }),
    });
}
exports.stytchFetchEmailResendMessage = stytchFetchEmailResendMessage;
